import React, { CSSProperties } from 'react';

const TriangleIcon = ({ className, style }: { className?: string | undefined, style?: CSSProperties | undefined }) => {
    return (
        <svg style={style} className={className} focusable="false" viewBox="0 0 24 24" aria-hidden="true">
            <path d="M12 2l10 20l-20 0z" fill="currentColor"></path>
        </svg>
    )
};

export default TriangleIcon;